import { Alert, ConfigProvider } from "antd";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { useSystemMaintenance } from "hooks/useSystemMaintenance";
import { useUserType } from "hooks/useUserType";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const MaintenanceAlert = () => {
  const isSystemMaintenance = useSystemMaintenance();
  const { isAdminUser } = useUserType();

  return (
    isSystemMaintenance &&
    !isAdminUser && (
      <ConfigProvider
        theme={{
          components: {
            Alert: {
              colorWarningBg: "#E75012"
            }
          }
        }}>
        <Alert
          message="System Alert"
          showIcon
          description={`The system has been reserved for use and will be unable to create jobs till the ${dayjs.utc(process.env.REACT_APP_BLOCK_FRONTEND_ACCESS_END_TIME_ISO).tz("Europe/Berlin").format("Do")} of ${dayjs.utc(process.env.REACT_APP_BLOCK_FRONTEND_ACCESS_END_TIME_ISO).tz("Europe/Berlin").format("MMMM")}.`}
          type="warning"
          style={{
            marginBottom: "8px"
          }}
        />
      </ConfigProvider>
    )
  );
};
